import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}

export interface ProductsItemInterface {
  coins?: number
  desc?: string
  dt?: number
  id?: string
  name?: string
  out_code?: string
  price?: number
  type?: string
  currency?: string
  chat_tag?: string
}
export interface ThirdPartyListItem {
  pay_method_id: number
  name: string
  img: string
  is_unfold: boolean
  list: Array<{
    product_id: string
    price: number
    coins: number
    currency: string
  }>
}

export interface ProductsListInterface {
  client_index: number // 客户端商品下标 需要进行优化，client_index为客户端充值渠道在第三方充值中的位置
  huawei_list: ProductsItemInterface[]
  list: ProductsItemInterface[]
  visa_list: ProductsItemInterface[]
  coins: number
  agreement_url: string
  tickets: number
  status: number
  exchange_cnt: number
  remain_tm: number
  is_recharged: number
  is_aristocracy: number
  before_recharged: number
  is_ra_customer: boolean
  exchange_tickets_ratio: number
  countries: Array<{
    code: number
    name: string
  }>
  default_country: {
    code: number
    name: string
  }
  third_party_list: ThirdPartyListItem[]
  is_union: number // 是否是公会主播
  recharge_version: 'v1' | 'v2' // 控制新版首充礼包AB文案
  is_first_recharge: boolean
  baseInfo?: {
    mid: number //	用户mid
    show_id: string //	用户展示ID
    avatar_url: string //	头像URL
    name: string // 用户昵称
    region_code: number
  }
  extra_desc_url: string // chat业务充值额外奖励说明页地址
  is_union_anchor: boolean // 是否是主播
  is_audit_ver: boolean // 是否是审核版本，如果是审核版本，需要屏蔽掉页面上的审核敏感内容
  is_recharge_limit: boolean // 谷歌苹果充值金额是否达到限制
}
const initialState: {
  wallet: ProductsListInterface
  chips: {
    chip_balance: number
    list: Array<{id: number; chips_amount: number; coins_price: number}>
  }
  walletDiamond: {
    overage: number // 余额（美元）
    total_diamond: number // 总钻石
    room_diamond: number // 直播间内钻石（可兑换的钻石）
    out_diamond: number // 直播间外钻石
    product_list: Array<{id: number; money: number; diamond: number}> // 产品列表
    is_exchange: boolean // 是否可以兑换
  }
} = {
  wallet: {
    client_index: 0,
    huawei_list: [],
    list: [],
    visa_list: [],
    coins: 0,
    agreement_url: '',
    tickets: 0,
    status: 0,
    exchange_cnt: 0,
    remain_tm: 0,
    is_recharged: 0,
    is_aristocracy: 0,
    before_recharged: 0,
    is_ra_customer: false,
    exchange_tickets_ratio: 0,
    countries: [],
    default_country: {
      code: 0,
      name: '',
    },
    third_party_list: [],
    is_union: 0, // 是否是公会主播
    recharge_version: 'v1', // 控制新版首充礼包AB文案
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: true,
    is_union_anchor: false, // 是否是主播
    is_recharge_limit: false, // 谷歌苹果充值金额是否达到限制
  },
  chips: {
    chip_balance: 0,
    list: [],
  },
  walletDiamond: {
    overage: 0,
    total_diamond: 0,
    room_diamond: 0,
    out_diamond: 0,
    product_list: [],
    is_exchange: true,
  },
}

export const getMyRechargeGroup = createAsyncThunk(
  'hiyaWallet2/getMyRechargeGroup',
  async (params, store: any) => {
    const resp = await http.post('/live/activity/sb_enter_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const createRechargeOrderV2 = createAsyncThunk(
  'hiyaWallet2/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
      from_page: string
      room_id: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const exchangeTickets = createAsyncThunk(
  'hiyaWallet2/exchangeTickets',
  async (param: {tickets: number}, store: any) => {
    const resp = await http.post('/live/user/exchange_tickets', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
      ...param,
    })
    return resp.data
  }
)

export const exchangeChips = createAsyncThunk(
  'hiyaWallet2/exchangeChips',
  async (
    {product_id, from}: {product_id: number; from?: string},
    store: any
  ) => {
    const resp = await http.post('/gamestore/common/account_exchange_in', {
      ...store.getState().env.deviceinfo,
      product_id,
      from,
    })
    return resp.data
  }
)

export const getChipsInfo = createAsyncThunk(
  'hiyaWallet2/getChipsInfo',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/account_info',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getChipsProductList = createAsyncThunk(
  'hiyaWallet2/getChipsProductList',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/chips_products',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getProductsList = createAsyncThunk(
  'hiyaWallet2/getProductsList',
  async (param: any = {}, store: any) => {
    const resp = await http.post('/live/pay/get_products_list', {
      ...store.getState().env.deviceinfo,
      ...param,
      before_recharged: 1,
    })
    return resp.data
  }
)

export const getRechargeBonus = createAsyncThunk(
  'hiyaWallet2/getRechargeBonus',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/recharge_bonus', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const simpleMemberByMid = createAsyncThunk(
  'hiyaWallet2/simpleMemberByMid',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)
// 【钱包 钻石信息】http://wiki.xunlei.cn/pages/viewpage.action?pageId=138980690
export const getWalletDiamond = createAsyncThunk(
  'hiyaWallet2/walletDiamond',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/settle/wallet',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const HiyaWalletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...data})
    })
    builder.addCase(getChipsProductList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(getChipsInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(simpleMemberByMid.fulfilled, (state, action) => {
      Object.assign(state.wallet, {
        baseInfo: action.payload,
      })
    })
    builder.addCase(getWalletDiamond.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.walletDiamond, {...data})
    })
  },
})
export default HiyaWalletSlice.reducer
